import { StyledLogoContainer, StyledText } from './MainScreen.styles'

export const Video = () => {
    return (
        <StyledLogoContainer>
            <iframe width="1152" height="576" src="https://www.youtube.com/embed/decirIh06NY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </StyledLogoContainer>
    )
}

export default Video;

